import * as React from 'react';
import { Link } from "react-router-dom";
import { getResourceString } from '../../kentico/resource-strings';

export interface MijnFNVProfielFotoProps {
    formPageUrl: string;
    photoUrl: string;
}

export class MijnFNVProfielFoto extends React.Component<MijnFNVProfielFotoProps> {
    
    render () {
        let photoUrl = this.props.photoUrl;
        if (!photoUrl) {
            photoUrl = "/assets/img/layout/user-profile.svg";
        }

        return <>
            <div className={"mijn-fnv__profiel-foto-block "}>
                <div className={"mijn-fnv__profiel-foto-block-titel"}>{getResourceString("MijnFNV.ProfielFoto.BlockTitel")}</div>
                <div style={{
                    backgroundImage: 'url("' + photoUrl + '")'
                }} className={"mijn-fnv__profiel-foto-block-image"}></div>
                <Link to={this.props.formPageUrl} className="btn btn-outline-primary">{getResourceString("MijnFNV.ProfielFoto.ButtonCaption")}</Link>
            </div>
        </>;
    }
}